import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    items: [],
    logItems: [],
    filters: {
      clientId: null,
      sequenceNumber: null,
    },
    duplicateIncidentData: {},
    originalIncidentData: {},
  },
  actions,
  mutations,
  getters: {},
};
